import React, { useRef, useState } from 'react';

import { useNavItemsWidth } from './hooks/useNavItemsWidth/useNavItemsWidth';
import { TrackingContext } from './hooks/useTracking/useTracking';
import * as styles from './DepartmentsNav.styles';
import { DepartmentsNavItem } from 'client-site-chrome-ui/components/molecules/DepartmentsNavItem/DepartmentsNavItem';
import { useSiteChromeDynamicContext } from 'client-site-chrome-ui/context/SiteChromeDynamicContext/useSiteChromeDynamicContext';
import type { Level1Item } from 'client-site-chrome-ui/types/departmentsNav';

export interface DepartmentsNavProps {
  className?: string;
  departments: Level1Item[];
}

export const DepartmentsNav = ({ className, departments }: DepartmentsNavProps) => {
  const {
    contentOverlay: { close, open },
    departmentsNavigation: { ref: navRef },
  } = useSiteChromeDynamicContext();
  const [openDepartmentIndex, setOpenDepartmentIndex] = useState(-1);
  const listRef = useRef<HTMLUListElement | null>(null);
  const { setNavItemRef } = useNavItemsWidth();

  return (
    <TrackingContext.Provider value={{ navigationData: departments }}>
      <nav className={className} css={styles.nav} ref={navRef}>
        <ul css={styles.list} ref={listRef}>
          {departments.map((department, index) => {
            const color = department.featured ? 'Red' : 'inherit';

            return (
              <DepartmentsNavItem
                color={color}
                department={department}
                index={index}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                openIndex={openDepartmentIndex}
                setNavClosed={() => {
                  setOpenDepartmentIndex(-1);
                  close();
                }}
                setNavOpen={(index: number) => {
                  setOpenDepartmentIndex(index);
                  const openDeptHasChildren = departments[index]?.items.length > 0;

                  if (openDeptHasChildren && navRef.current) {
                    const navBottom = navRef.current.getBoundingClientRect().bottom;

                    open(navBottom + window.scrollY);
                  }
                }}
                setRef={(ref) => setNavItemRef(ref, index)}
              />
            );
          })}
        </ul>
      </nav>
    </TrackingContext.Provider>
  );
};
